import { filter, find } from 'lodash';
import { action, observable } from 'mobx';
import { AppContextInterface } from '../../App';
import { ActionType, MessageType } from '../types/FlexCommunication';

declare global {
  interface Window {
    connectFlex: any;
    onMessage: any;
    onLoad: any;
  }
}

export class FlexMessageGateway {
  @observable type: MessageType | null;
  @observable context: AppContextInterface | null;
  @observable event: CustomEvent | null;
  @observable queue: any[];

  constructor() {
    this.addEventList();
    this.event = null;
    this.type = null;
    this.context = null;
    this.queue = [];
  }

  onMessage = (event: any) => {
    if (event && event.data && event.data.action) {
      switch (event.data.action) {
        case ActionType.LOGIN:
          if (event.data && event.data.data && event.data.data.user && event.data.data.commodity) {
            const user = event.data.data.user;
            const commodity = event.data.data.commodity;

            this.context?.app.storeUserCredentials(user);
            this.context?.app.setSelectedCommodity(commodity);
          }

          break;
        case ActionType.CHANGE_FLEX_TERMINAL:
          if (event?.data?.data?.terminalId) {
            this.context?.app.setTerminalSelectedFilter([event.data.data.terminalId]);
          }
          break;

        case ActionType.CHANGE_COMMODITY:
          if (event.data && event.data.data) {
            const commodity = event.data.data;
            this.context?.app.setSelectedCommodity(commodity);
          }
          break;

        case ActionType.ACTIVATE_TAB:
          if (event.data && event.data.data) {
            const activeSetupTab = event.data.data;
            this.context?.app.setActiveTab(activeSetupTab);
          }
          break;

        default:
          this.addQueue({ ...event.data, type: this.type, id: Date.now() });
          break;
      }
    }
  };

  @action setType(type: MessageType) {
    this.type = type;
  }

  @action setContext(context: AppContextInterface) {
    this.context = context;
  }

  @action setQueue(data: any) {
    this.queue = data;
  }

  @action addQueue(data: any) {
    this.queue.push(data);
  }

  @action dispatchQueue(type: string) {
    const d = find(this.queue, { type });
    if (d) {
      this.setQueue(filter(this.queue, v => v.id !== d.id));
      return d;
    }
    return null;
  }

  postMessage = (action: string, data?: any) => {
    window.parent.postMessage({ action, data, type: this.type }, '*');
  };

  dispatchEventFlexMessage = (data: any) => {
    window.dispatchEvent(new CustomEvent('flexMessageGateway', { detail: data }));
  };

  setMessageEventListener = (callback: any) => {
    window.addEventListener('flexMessageGateway', callback, false);
  };

  addEventList() {
    if (window.addEventListener) {
      window.addEventListener('message', this.onMessage, false);
    }
  }
}

const flexMessageGateway = new FlexMessageGateway();

export default flexMessageGateway;
